import { useEffect } from "react";

export default function useTimeout(callback: Function, delay: number) {
  useEffect(() => {
    const id = setTimeout(callback, delay);
    return () => clearTimeout(id);
  }, [delay])
}
